// extracted by mini-css-extract-plugin
module.exports = {"iconAccept":"messages_iconAccept__2T2NS mr-3 cursor-pointer","iconDecline":"messages_iconDecline__UNTA1 cursor-pointer"};